import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from './api/baseApi';
import { baseApi as conversationApi } from './api/conversationApi';

import { combinedReducer } from './ducks';

import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { localStorageMiddleware } from './middlewares/localStorageMiddleware';
import { loadCustomizerState } from './utils/preload.utils';

const preloadedThemeState = loadCustomizerState();

export const store = configureStore({
  reducer: combinedReducer,
  preloadedState: preloadedThemeState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      baseApi.middleware,
      conversationApi.middleware,
      localStorageMiddleware,
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const { dispatch } = store;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
